import { cloudChiprApi } from "../../../../../../services/cloudchipr.api";

export const getUsersMeOrganisationsCurrentSavingsPlansSelector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentSavingsPlans.select;
